import { reduce } from 'lodash'

export const replaceKey = (obj, oldKey, newKey) => {
  obj[newKey] = obj[oldKey]
  delete obj[oldKey]
  return obj
}

export const chooseAllRecipes = ({ formData, data }, isSelect) => {
  return reduce(
    formData,
    (res, value, key) => {
      if (!isSelect) {
        return { ...res, [key]: { ...value, recipes: [] } }
      }
      const findObject = Object.values(data).find(
        ({ categoryId }) => value.categoryId === categoryId
      )
      const recipes = findObject.recipes.map(({ id }) => id)

      return { ...res, [key]: { ...value, recipes } }
    },
    {}
  )
}

export const recipesOrder = ({ data, isReset = false }) => {
  const setDefaultRecipes = (data) => {
    return reduce(
      data,
      (result, value) => (value?.is_selected ? [...result, value?.id] : result),
      []
    )
  }

  return reduce(
    data,
    (res, value, key) => {
      const recipes = isReset ? setDefaultRecipes(value.recipes) : value?.recipes
      return { ...res, [value?.name]: { recipes, categoryId: key } }
    },
    {}
  )
}

export const countNumberRecipes = (data) => {
  return reduce(data, (res, item) => [...res, ...item.recipes], [])?.length
}
